import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/nuxt-app/layouts/default.vue").then(m => m.default || m)),
  preview: defineAsyncComponent(() => import("/usr/src/nuxt-app/layouts/preview.vue").then(m => m.default || m))
}